































import { Mixins, Component, Watch } from 'vue-property-decorator';
import { isEmpty } from 'lodash';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import AuthWrapper from '@/components/global/AuthWrapper.vue';
import EmailConfirmationAfterRegister from '@/components/emailConfirmation/EmailConfirmationAfterRegister.vue';
import EmailConfirmationWithCode from '@/components/emailConfirmation/EmailConfirmationWithCode.vue';


import moment from 'moment';

const uuidv4 = require('uuid/v4');

@Component({
    components: {
        AuthWrapper,
        EmailConfirmationAfterRegister,
        EmailConfirmationWithCode,
    },
})
export default class EmailConfirmation extends Mixins(IsMobileMixin) {
    public goToSignIn() {
        this.$router.push('/signin');
    }

    get aspectRatio() {
        if (!this.isTablet) {
            return 16 / 10;
        }
        return 'false';
    }

    get query(): any {
        return this.$route.query;
    }

    @Watch('query', { immediate: true })
    private onQueryChange(val: any) {
        if (isEmpty(val)) this.$router.replace({ name: 'page-not-found' });
    }
}
